import { General } from "@/services/General";
import axios from "axios";

export class Channel {
    public id: string;
    public description: string;
}

export enum CHANNEL_DETAIL {
    TRUCK = 1,
    CAR = 2,
    AGRI = 3,
    MOTO = 4
}

export async function GetDropDownChannelsForUser(idCountry: string): Promise<any[]> {
    if(idCountry != null) {
        try{
            let response = await axios.get<Channel[]>(
                General.GetApiUrl('/api/net20/GetChannelsForUser?idCountry=' + idCountry),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                return setOptionsDropDownChannel(response.data);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
}

export async function GetDropDownChannels(): Promise<any[]> {
    try{
        let response = await axios.get<Channel[]>(
            General.GetApiUrl('/api/net20/GetAllChannelsDetail'),{
            responseType: "json",
            withCredentials: true
        });
        if(response.data) {
            return setOptionsDropDownChannel(response.data);
        }
    } catch(ex) {
        General.HandleError(ex, this);
        return null;
    }
}

export function setOptionsDropDownChannel(channels: Channel[]){
    let array: Array<any> = [];
    array.push({ value: null, text: "" });
    channels.forEach(function (el) {
        array.push({ value: el.id, text: el.description });
    });
    return array;
}